import api from "../../service/api"
import routes from "../../service/apiRoutes"

export const getReport = (reportId) => api.get(routes.report, { params: { report_id: reportId }, noauth: true})
export const addTargets = (data) => api.post(routes.addTargets, data, { noauth: true })